export class JsonHelper {
    // Helper method to lowercase the first letter of a string
    private static lowercaseFirstLetter(str: string): string {
        return str.charAt(0).toLowerCase() + str.slice(1);
    }

    // Method to parse JSON and transform the keys
    public static parseAndTransformJson(jsonString: string): any {
        const obj = JSON.parse(jsonString);
        return this.transformKeys(obj);
    }

    // Recursive function to transform the keys of an object
    private static transformKeys(obj: any): any {
        if (Array.isArray(obj)) {
            return obj.map(this.transformKeys); // Recursively transform arrays
        } else if (obj !== null && typeof obj === 'object') {
            const transformedObj: any = {};
            for (const key of Object.keys(obj)) {
                const newKey = this.lowercaseFirstLetter(key);
                transformedObj[newKey] = this.transformKeys(obj[key]);
            }
            return transformedObj;
        }
        return obj;
    }
}
